import { Skeleton, Text } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'
import React, { FunctionComponent } from 'react'
import { useMoney } from '../Money/useMoney'
import { Currency } from '../../model'
import { useAppRouter } from '../../state'
import styles from './style.module.css'
import { MoneyPrefix, MoneyProps } from './types'

export const Money: FunctionComponent<MoneyProps> = ({
  value,
  size = 'XS',
  strikethrough = false,
  bold = false,
  showFree = false,
  loading = false,
  color = 'Black',
  locale,
  testNameSpace,
  mintBar = false,
  decimalPlaces = 2,
  prefix = MoneyPrefix.NONE,
  showAsterisk = false,
}) => {
  const { locale: appLocale } = useAppRouter()
  const { t } = useTranslation()
  const { formatMoney } = useMoney({
    locale: locale ?? appLocale,
    currency: value?.currency as Currency | undefined,
    decimalPlaces,
  })

  const moneyProps = {
    ...(color !== 'IGNORE' && { color }),
  }

  const renderValue = (): string => {
    const amount = value?.amount
    if (showFree && Number(amount) === 0) {
      return t('common:free')
    } else {
      return `${prefix}${formatMoney(amount)}${showAsterisk ? '*' : ''}`
    }
  }

  const getDataTestId = (suffix: string): string => {
    if (typeof testNameSpace !== 'undefined' && testNameSpace.length > 0) {
      return `${testNameSpace}-${suffix}`
    }
    return ''
  }

  return (
    <Text
      mintBar={mintBar}
      size={size}
      strikethrough={strikethrough}
      bold={bold}
      renderAs='span'
      testNameSpace={getDataTestId('text-money-wrapper')}
      {...moneyProps}
    >
      <span className={loading ? styles.visuallyInvisible : ''} data-testid={getDataTestId('text-money')}>
        {renderValue()}
      </span>
      {loading && <Skeleton testNameSpace={getDataTestId('text-skeleton')} />}
    </Text>
  )
}
